import OapIframe from './code/Scripts/components/oap-iframe.vue';

export default {
  components: {
    OapIframe,
  },
};
